export const SPORT_TREE_FETCH_PENDING = 'SPORT_TREE_FETCH_PENDING';
export const SPORT_TREE_FETCH_SUCCESS = 'SPORT_TREE_FETCH_SUCCESS';
export const SPORT_TREE_FETCH_ERROR = 'SPORT_TREE_FETCH_ERROR';
export const SPORT_MENU_FETCH_SUCCESS = 'SPORT_MENU_FETCH_SUCCESS';
export const SPORT_INFO = 'SPORT_INFO';
